<!--  -->
<template>
  <div class="myPopup">
    <van-popup v-model="forceRead">
      <div class="myPopupContent">
        <div class="myPopupContentHeader">
          <van-icon
            @click="clickClose"
            name="cross"
          />
        </div>
        <div class="myPopupContentCenter">
          <PDF
            :urlLink="url"
          ></PDF>
        </div>
        <van-button
          class="vanButton handeCopy"
          :disabled="forceReadText !== '我已阅读'"
          @click="clickAgree"
          color="#FF6538"
          type="primary"
        >{{forceReadText}}</van-button>
        <!-- <div v-if="forceReadText" @click="forceReadSure" class="forceReadBtn" :class="forceReadText !== '我已阅读' ? 'disable' : ''">{{forceReadText}}</div> -->
      </div>
    </van-popup>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { Toast } from 'vant';
import PDF from '@/components/PDF/index.vue';
var clearIv = null;
export default {
  name: 'pdfContract',
  components: {
    PDF,
  },
  props: ['agreeWithAgreement', 'checked', 'value', 'contractId', 'orderId', 'drawId'],
  data() {
    return {
      counts: 10,
      forceReadText: `我已阅读`,
      
      forceRead: false,
      copyText: '',
      toast: null,
      count: 1,
    };
  },
  computed: {
    url() {
      return `${window.location.origin}/backloansuper/loan/supermarket/contDrawQuerySpdb/v1.0?orderId=${this.orderId || window.sessionStorage.getItem('orderId')}&drawId=${this.drawId}&type=1`;
    },
    copyUrl() {
      return `${window.location.origin}/backloansuper/loan/supermarket/contDrawQuerySpdb/v1.0?orderId=${this.orderId || window.sessionStorage.getItem('orderId')}&drawId=${this.drawId}&type=2`;
    },
  },
  mounted() {
  },
  methods: {
    clickAgree() {
      this.$emit('checked', true);
      this.forceRead = false;
    },
    clickClose() {
      this.forceRead = false;
    },
    handeCopy() {
      const clipboard = new Clipboard('.handeCopy', {
        text(trigger) {
          console.log(trigger);
          return trigger.getAttribute('aria-label');
        },
      });
      clipboard.on('success', () => {
        Toast('复制成功');
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on('error', () => {
        // 不支持复制 console.log('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy();
      });
    },

  },
  watch: {
    forceRead: {
      handler() {
        this.$emit('input', this.forceRead);
      },
    },
    value: {
      handler(val) {
        this.forceRead = !!val;
      },
    },
    forceRead: {
      handler(val) {
        if(!this.agreeWithAgreement && val) {
          this.counts = 10; 
          // this.forceRead = true;
          this.forceReadText = `我已阅读(${this.counts--})`;
          clearIv = setInterval(() => {
            if(this.counts > 0) {
              this.forceReadText = `我已阅读(${this.counts--})`;
            } else {
              this.forceReadText = `我已阅读`;
            }
          }, 1000)
        } else {
          // this.count = !this.agreeWithAgreement ? 5 : 0;
          this.agreeWithAgreement = false;
          this.$emit('input', false);
          clearInterval(clearIv);
        }
      },
    },
  },
};
</script>
<style scoped>
.myPopupContent {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.myPopup >>> .van-popup--center {
  border-radius: 8px;
  width: 85%;
  height: 85%;
}
.myPopupContentHeader {
  width: 100%;
  background: #fff;
  height: 50px;
  border-bottom: 1px solid #e9f0f5;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  font-size: 12;
  color: #687282;
  margin-right: 20px;
}
.myPopupContentCenter {
  flex: 1;
  overflow: auto;
}
.vanButton {
  width: 91%;
  height: 44px;
  margin: 16px;
}
.van-button--disabled {
  border: 0;
  background: #d7d7d7 !important;
  opacity: 1;
}
</style>
